import React from 'react';
import handler from '../../../../components/shared/inputHandler';

const months = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const filterFieldsRow = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px 10px',
  width: '100%',
};

const labelSpan = { fontSize: 12, color: '#475569', fontWeight: 500 };

const FilterHandler = (type) => {
  if (type === '1') {
    return (
      <div style={filterFieldsRow} className="filter-date-fields-row">
        <span style={labelSpan} className="filter-date-label">De</span>
        <div className="filter-date-input-wrap">
          {handler({
            name: 'initial_date',
            label: '',
            size: 'field-fc',
            isRequired: false,
            type: 'maskedText',
            value: '',
            hasValidation: true,
            props: {
              regex: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
            },
          })}
        </div>
        <span style={labelSpan} className="filter-date-label">a</span>
        <div className="filter-date-input-wrap">
          {handler({
            name: 'end_date',
            label: '',
            size: 'field-fc',
            isRequired: false,
            type: 'maskedText',
            value: '',
            hasValidation: true,
            props: {
              regex: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
            },
          })}
        </div>
      </div>
    );
  }
  const filterYears = [];
  for (let i = new Date().getFullYear(); i >= 2019; i -= 1) {
    filterYears.push({ value: i.toString(), label: i.toString() });
  }
  return (
    <div style={filterFieldsRow} className="filter-month-fields-row">
      <span style={labelSpan}>Ano</span>
      <div className="filter-date-input-wrap filter-date-input-wrap--year">
        {handler({
          name: 'year_filter',
          label: '',
          size: 'field-fc',
          type: 'select',
          hasValidation: true,
          options: filterYears,
        })}
      </div>
      <span style={labelSpan}>Mês</span>
      <div className="filter-date-input-wrap filter-date-input-wrap--month">
        {handler({
          name: 'month_filter',
          label: '',
          size: 'field-fc',
          type: 'select',
          hasValidation: true,
          options: months.map((month, index) => ({ value: index, label: month })),
        })}
      </div>
    </div>
  );
};

export default FilterHandler;
